import styled from 'styled-components';
import { prefix } from '../../../tools/settings';
var ModalHeader = styled.div.withConfig({
  displayName: "Headerstyles__ModalHeader",
  componentId: "sc-v51rcn-0"
})(["background:var(--dentsu-color-white);padding:var(--dentsu-spacing-16) var(--dentsu-spacing-24) var(--dentsu-spacing-12);border-bottom:1px solid var(--dentsu-color-n150);position:relative;display:flex;flex:0 0 auto;align-items:flex-start;font-family:var(--dentsu-font-family-sans);text-align:left;&.", "-modal__header--branded{background:var(--dentsu-color-n100);padding:var(--dentsu-spacing-24);}"], prefix);
var Logo = styled.div.withConfig({
  displayName: "Headerstyles__Logo",
  componentId: "sc-v51rcn-1"
})(["background:var(--dentsu-color-white);width:96px;height:96px;border-radius:48px;display:flex;align-items:center;justify-content:center;margin-right:var(--dentsu-spacing-24);"]);
var Title = styled.div.withConfig({
  displayName: "Headerstyles__Title",
  componentId: "sc-v51rcn-2"
})(["flex:1;display:flex;flex-direction:column;"]);
var Metadata = styled.h4.withConfig({
  displayName: "Headerstyles__Metadata",
  componentId: "sc-v51rcn-3"
})(["font-size:var(--dentsu-font-size-12);font-weight:var(--dentsu-font-weight-regular);color:var(--dentsu-color-n700);line-height:var(--dentsu-leading-tight);.", "-modal__header--branded &{order:2;}"], prefix);
var Heading = styled.h3.withConfig({
  displayName: "Headerstyles__Heading",
  componentId: "sc-v51rcn-4"
})(["color:var(--dentsu-color-n1000);font-size:var(--dentsu-font-size-24);font-weight:var(--dentsu-font-weight-semibold);line-height:var(--dentsu-leading-tight);margin:0;padding:0;overflow:visible;text-overflow:inherit;white-space:normal;.", "-modal__header--branded &{order:1;}&:last-child{margin-right:0;}"], prefix);
var Chips = styled.div.withConfig({
  displayName: "Headerstyles__Chips",
  componentId: "sc-v51rcn-5"
})(["order:3;margin-top:var(--dentsu-spacing-16);.", "-chip{&:first-of-type{margin-left:0;}}"], prefix);
var Actions = styled.div.withConfig({
  displayName: "Headerstyles__Actions",
  componentId: "sc-v51rcn-6"
})(["display:flex;flex-direction:column;padding:var(--dentsu-spacing-12) var(--dentsu-spacing-16);.", "-button,.", "-link{margin:var(--dentsu-spacing-4) 0;}"], prefix, prefix);
var CloseButton = styled.button.withConfig({
  displayName: "Headerstyles__CloseButton",
  componentId: "sc-v51rcn-7"
})(["position:absolute;top:var(--dentsu-spacing-12);right:var(--dentsu-spacing-12);border:none;background:none;outline:none;&:hover{cursor:pointer;.", "-icon{color:var(--dentsu-color-n850);}}.", "-icon{color:var(--dentsu-color-b550);margin-right:0;}"], prefix, prefix);
export var Styled = {
  Actions: Actions,
  Chips: Chips,
  CloseButton: CloseButton,
  Logo: Logo,
  ModalHeader: ModalHeader,
  Title: Title,
  Heading: Heading,
  Metadata: Metadata
};